import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './app/app';
import { msalInstance } from '@utils';
import { b2cLogin } from '@utils';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';

const queryClient = new QueryClient();

msalInstance.initialize().then(() => {
  b2cLogin();
  createRoot(document.getElementById('root') as HTMLElement).render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <App />
      </QueryClientProvider>
    </StrictMode>,
  );
});
